/** Settings page tab slugs (order matches tab indices). */
export const SETTINGS_TAB_IDS = [
  'profile',
  'payment',
  'security',
  'activity',
  'subscription',
  'branding',
  'team',
];

export function settingsTabIndexFromSearch(search) {
  const q = new URLSearchParams(search || '');
  const t = (q.get('tab') || 'profile').toLowerCase();
  const idx = SETTINGS_TAB_IDS.indexOf(t);
  return idx >= 0 ? idx : 0;
}

export function settingsTabIdFromIndex(index) {
  return SETTINGS_TAB_IDS[index] || 'profile';
}
